var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStarOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.539 14.581l5.461-4.992-7.205-0.654-2.794-6.929-2.794 6.929-7.205 0.654 5.461 4.992-1.635 7.419 6.172-3.924 6.172 3.923zM12.001 16.105v0l-3.756 2.391 1-4.517-3.327-3.039 4.389-0.4 1.693-4.21 1.693 4.21 4.389 0.4-3.327 3.036 1 4.517z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-outline.e938017f.svg";
export { ForwardRef as ReactComponent };